/* eslint-disable max-len */
import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

class IconCalendar8 extends React.Component {
  render() {
    const iconClasses = classNames("icon calendar8", this.props.className);
    return (
      <svg
        className={iconClasses}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 30 30"
      >
        <path d="M 6 4 C 4.895 4 4 4.895 4 6 L 4 24 C 4 25.105 4.895 26 6 26 L 24 26 C 25.105 26 26 25.105 26 24 L 26 6 C 26 4.895 25.105 4 24 4 L 6 4 z M 6 6 L 24 6 L 24 10 L 6 10 L 6 6 z M 14.998047 14.306641 C 16.584047 14.306641 17.724609 15.122 17.724609 16.25 C 17.724609 16.992 17.19725 17.598531 16.40625 17.769531 L 16.40625 17.861328 C 17.36725 18.037328 18.011719 18.750438 18.011719 19.648438 C 18.010719 20.893437 16.795187 21.734375 14.992188 21.734375 C 13.195187 21.734375 11.990234 20.904062 11.990234 19.664062 C 11.990234 18.795063 12.618797 18.086328 13.591797 17.861328 L 13.591797 17.769531 C 12.800797 17.598531 12.273438 16.993 12.273438 16.25 C 12.273438 15.122 13.410047 14.306641 14.998047 14.306641 z M 14.998047 15.53125 C 14.436047 15.53125 14.035156 15.908016 14.035156 16.416016 C 14.035156 16.924016 14.441047 17.294922 14.998047 17.294922 C 15.555047 17.294922 15.955078 16.924016 15.955078 16.416016 C 15.955078 15.908016 15.555047 15.53125 14.998047 15.53125 z M 14.998047 18.515625 C 14.328047 18.515625 13.865234 18.920094 13.865234 19.496094 C 13.865234 20.077094 14.328047 20.474609 14.998047 20.474609 C 15.666047 20.474609 16.125 20.077094 16.125 19.496094 C 16.125 18.920094 15.662047 18.515625 14.998047 18.515625 z" />
      </svg>
    );
  }
}

IconCalendar8.defaultProps = {
  className: null
};

IconCalendar8.propTypes = {
  className: PropTypes.string
};

export default IconCalendar8;
